import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import {Link as DomLink} from "react-router-dom";
// Assets
import LogoImg from "../../assets/img/Logo-primary.svg";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>
            
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="purpleColor font13">Aussie Everest</span> All Right Reserved
            </StyleP>
            <DomLink className="whiteColor animate pointer font13" to="/privacy-policy">
              Privacy Policy
            </DomLink>
            <Link className="whiteColor animate pointer font13" to="home" smooth={true} offset={0}>
              Back to top
            </Link>

          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;